import {
    AttachmentService
} from '@/common/api.service.js'

export class Attachment {
    constructor ({
        created_at = null,
        id = null,
        path = null,
        size = null,
        title = null,
        type = null,
        updated_at = null
    } = {}) {
        this.created_at = created_at
        this.id = id
        this.path = path
        this.size = size
        this.title = title
        this.type = type
        this.updated_at = updated_at
    }
}

export function responseAdapter (response) {
    return new Attachment({
        ...response
    })
}

export function requestAdapter (request) {
    return request
}

export function queryAdapter (query) {
    if (!query._page) return query
    let offset = query._page - 1 * query._limit
    if (offset > 0) query._offset = offset
    return query
}

export default {
    getList: params => new Promise((resolve, reject) => {
        AttachmentService.query(queryAdapter(params))
            .then(({
                data,
                headers
            }) => {
                resolve({
                    data: data.map(x => responseAdapter(x)),
                    headers
                })
            }).catch(e => {
                reject(e)
            })
    }),
    create: attachment => new Promise((resolve, reject) => {
        AttachmentService.create(requestAdapter(attachment))
            .then((
                data
            ) => {
                resolve(data)
            }).catch(e => {
                reject(e)
            })
    }),
    delete: id => new Promise((resolve, reject) => {
        AttachmentService.remove(id)
            .then((
                data
            ) => {
                resolve(data)
            })
            .catch(e => {
                reject(e)
            })
    })
}
